var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelegramIcon = function SvgTelegramIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 33 28"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#telegramIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    fillRule: "evenodd",
    d: "m17.298 21.512-3.481 3.235c-.426.397-1.12.071-1.08-.51.108-1.644.277-4.142.39-5.53.019-.22.203-.464.379-.623 4.065-3.686 8.14-7.363 12.213-11.044.151-.136.33-.471.236-.648-.106-.2-.594-.139-.796-.012-5.174 3.257-10.347 6.513-15.512 9.781-.317.2-.706.248-1.062.133-2.13-.684-4.273-1.333-6.408-2.006-.49-.156-1.074-.31-1.13-.919-.059-.636.487-.938.98-1.136 1.985-.8 3.983-1.567 5.98-2.337Q18.774 5.746 29.543 1.6c.24-.092.56-.15.812-.2.752-.15 1.429.227 1.503.989.056.557-.042 1.178-.159 1.73-1.495 7.114-3.01 14.225-4.525 21.338-.408 1.922-1.396 2.286-2.986 1.112-2.05-1.514-6.891-5.057-6.891-5.057",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "telegramIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5.724h32v26.553H.5z"
  })))));
};
export default SvgTelegramIcon;